import React, { useEffect, useState } from 'react';
import {
  ModalActionAddressContainer,
  ModalActionAddressContent,
  ModalActionAddressHead,
  ModalActionAddressBody,
  ModalActionAddressBodyLabel,
  ModalActionAddressBodyDescription,
  ModalActionAddressFooter,
  SecondaryLargeButton,
  InputDefaultField,
  ModalActionAddressBodySelect,
  ModalActionOtro,
  ModalActionSign
} from './styles';
import { IoClose } from 'react-icons/io5';
import { BsExclamation } from 'react-icons/bs';
import colors from '../../assets/styles/colors';
import Select from '../../components/Select';
import SearchField from '../../components/SearchField';
import { AddressNomenclatura1, AddressNomenclatura2, AddressNomenclatura3, AddressNomenclatura4, zonasRurales } from '../../helpers/enum';
import ModalInfo from '../../components/ModalInfo';

const ModalActionAddress = ({ open, setShowModal, actionFunctionDownButton, name, setValue }) => {
  const [direccion, setDireccion] = useState('');
  const [adicional, setAdicional] = useState('');
  const [numero1, setNumero1] = useState('');
  const [numero2, setNumero2] = useState('');
  const [numero3, setNumero3] = useState('');
  const [calle, setCalle] = useState('');
  const [letra1, setLetra1] = useState('');
  const [letra2, setLetra2] = useState('');
  const [letra3, setLetra3] = useState('');
  const [complemento, setComplemento] = useState('');
  const [complemento2, setComplemento2] = useState('');
  const [showCalle, setShowCalle] = useState(false);
  const [showLetra1, setShowLetra1] = useState(false);
  const [showLetra2, setShowLetra2] = useState(false);
  const [showLetra3, setShowLetra3] = useState(false);
  const [showComplemento, setShowComplemento] = useState(false);
  const [showComplemento2, setShowComplemento2] = useState(false);
  const [filteredAddressNomenclatura1, setFilteredAddressNomenclatura1] = useState([]);
  const [filteredAddressNomenclatura3, setFilteredAddressNomenclatura3] = useState([]);
  const [filteredAddressNomenclatura3_2, setFilteredAddressNomenclatura3_2] = useState([]);
  const [showModalInfo, setShowModalInfo] = useState('');
  const [direccionRural, setDireccionRural] = useState('');
  const [zonaRural, setZonaRural] = useState(false);

  function setSelectedCalle(field) {
    setCalle(field.id);
    setShowCalle(false);
    document.getElementById("calleModal").value = field.nombre;
  }

  function setSelectedComplemento(field) {
    setComplemento(field.nombre);
    setShowComplemento(false);
    document.getElementById("complementoModal").value = field.nombre;
  }

  function setSelectedComplemento2(field) {
    setComplemento2(field.nombre);
    setShowComplemento2(false);
    document.getElementById("complementoModal2").value = field.nombre;
  }

  function setSelectedLetra1(letra) {
    setLetra1(letra.nombre);
  }

  function setSelectedLetra2(letra) {
    setLetra2(letra.nombre);
  }

  function setSelectedLetra3(letra) {
    setLetra3(letra.nombre);
  }

  function searchInCalle(e) {
    if (e.target.value.trim() == '') {
      setCalle('');
    }
    setShowCalle(true);
    setShowLetra1(false);
    setShowLetra2(false);
    setShowComplemento(false);
    setShowComplemento2(false);
    const filtered = AddressNomenclatura1.filter(address => address.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredAddressNomenclatura1(filtered);
  }

  function searchInComplemento(e) {
    if (e.target.value.trim() == '') {
      setComplemento('');
    }
    setShowComplemento(true);
    setShowComplemento2(false);
    setShowLetra1(false);
    setShowLetra2(false);
    setShowCalle(false);
    const filtered = AddressNomenclatura3.filter(address => address.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredAddressNomenclatura3(filtered);
  }

  function searchInComplemento2(e) {
    if (e.target.value.trim() == '') {
      setComplemento2('');
    }
    setShowComplemento2(true);
    setShowComplemento(false);
    setShowLetra1(false);
    setShowLetra2(false);
    setShowCalle(false);
    const filtered = AddressNomenclatura3.filter(address => address.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredAddressNomenclatura3_2(filtered);
  }

  function guardarDireccion() {
    if (zonaRural) {
      setValue(name, direccion)
      closeList();
      actionFunctionDownButton();
    } else {
      if (calle.trim() !== "" && numero1.trim() !== "" && numero2.trim() !== "" && numero3.trim() !== "") {
        setValue(name, direccion);
        closeList();
        actionFunctionDownButton();
      } else {
        setShowModalInfo(true);
      }
    }

  }

  function closeList() {
    setShowCalle(false);
    setShowLetra1(false);
    setShowLetra2(false);
    setShowLetra3(false);
    setShowComplemento(false);
    setShowComplemento2(false);
  }

  useEffect(() => {
    if(zonaRural){
      const dir = calle.toUpperCase() + " " + adicional.toUpperCase();
      setDireccion(dir.replace(/\s+/g, " ").replace("# -", "").trim());
    }else{
      const dir = calle.toUpperCase() + " " + numero1.toUpperCase() + " " + letra1.toUpperCase() + " " + letra3 + " " + complemento.toUpperCase() + " # " + numero2.toUpperCase() + " " + letra2.toUpperCase() + " - " + numero3.toUpperCase() + " " + complemento2.toUpperCase() + " " + adicional.toUpperCase();
      setDireccion(dir.replace(/\s+/g, " ").replace("# -", "").trim());
    }
  }, [calle, numero1, letra1, letra3, complemento, numero2, letra2, numero3, complemento2, adicional, direccionRural]);

  useEffect(() => {
    setZonaRural(zonasRurales.some(loc => loc.id == calle))
    setAdicional('')
  }, [calle]);

  return (
    <ModalActionAddressContainer open={open} id="modal-action">
      <ModalActionAddressContent>
        <ModalActionAddressHead setShowModal={setShowModal}>
          {setShowModal && <IoClose size={26} color={colors.textSecondary} onClick={() => { closeList(); setShowModal(false); }} id="close-icon" />}
        </ModalActionAddressHead>
        <ModalActionAddressBody>
          <ModalActionAddressBodyLabel>Registrar Dirección:</ModalActionAddressBodyLabel>
          <ModalActionAddressBodyDescription></ModalActionAddressBodyDescription>
          <ModalActionAddressBodySelect>
            <ModalActionOtro>
              Nomenclatura
              <SearchField
                show={showCalle}
                selectField={setSelectedCalle}
                list={filteredAddressNomenclatura1}
                defaultValue={calle}
                id="calleModal"
                searchInList={searchInCalle}
                placeholder="Seleccionar..." />
            </ModalActionOtro>
          </ModalActionAddressBodySelect>
          {(!zonasRurales.some(loc => loc.id == calle)) &&
            <>
              <ModalActionAddressBodySelect>
                <ModalActionOtro>
                  Número/Descrip
                  <InputDefaultField
                    style={{ width: "200px" }}
                    value={numero1}
                    onInput={e => setNumero1(e.target.value)} />
                </ModalActionOtro>
                <ModalActionOtro style={{ width: "50px", "margin-right": "30px" }}>
                  Vía principal
                  <Select
                    setShow={setShowLetra1}
                    show={showLetra1}
                    setSelected={setSelectedLetra1}
                    list={AddressNomenclatura2}
                    defaultValue={letra1}
                    placeholder="..." />
                </ModalActionOtro>
                <ModalActionOtro>
                  Vía 2
                  <Select
                    setShow={setShowLetra3}
                    show={showLetra3}
                    setSelected={setSelectedLetra3}
                    list={AddressNomenclatura4}
                    defaultValue={letra3}
                    placeholder="..." />
                </ModalActionOtro>
                <ModalActionOtro>
                  Sector
                  <SearchField
                    show={showComplemento}
                    selectField={setSelectedComplemento}
                    list={filteredAddressNomenclatura3}
                    defaultValue={complemento}
                    id="complementoModal"
                    searchInList={searchInComplemento}
                    placeholder="Seleccionar..." />
                </ModalActionOtro>
              </ModalActionAddressBodySelect>
              <ModalActionAddressBodySelect style={{ "margin-top": "30px" }}>
                <ModalActionSign>#</ModalActionSign>
                <ModalActionOtro>
                  Número
                  <InputDefaultField
                    style={{ width: "50px" }}
                    value={numero2}
                    onInput={e => setNumero2(e.target.value)} />
                </ModalActionOtro>
                <ModalActionOtro style={{ width: "50px" }}>
                  Vía principal
                  <Select
                    setShow={setShowLetra2}
                    show={showLetra2}
                    setSelected={setSelectedLetra2}
                    list={AddressNomenclatura2}
                    defaultValue={letra2}
                    placeholder="..." />
                </ModalActionOtro>
                <ModalActionSign>-</ModalActionSign>
                <ModalActionOtro>
                  Número/Descrip
                  <InputDefaultField
                    style={{ width: "200px" }}
                    value={numero3}
                    onInput={e => setNumero3(e.target.value)} />
                </ModalActionOtro>
                <ModalActionOtro>
                  Sector
                  <SearchField
                    show={showComplemento2}
                    selectField={setSelectedComplemento2}
                    list={filteredAddressNomenclatura3_2}
                    defaultValue={complemento2}
                    id="complementoModal2"
                    searchInList={searchInComplemento2}
                    placeholder="Seleccionar..." />
                </ModalActionOtro>
              </ModalActionAddressBodySelect>
            </>
          }
          {calle &&
            <>
              <ModalActionAddressBodyDescription>Datos adicionales</ModalActionAddressBodyDescription>
              <InputDefaultField
                value={adicional}
                onInput={e => {
                  const inputValue = e.target.value.slice(0, 50);
                  setAdicional(inputValue);
                }}
                maxLength="50"
              />
            </>}
          <ModalActionAddressBodyDescription>Dirección completa</ModalActionAddressBodyDescription>
          <InputDefaultField
            value={direccion}
            disabled="true"
            onInput={e => setDireccion(e.target.value)} />
        </ModalActionAddressBody>
        <ModalActionAddressFooter>
          <SecondaryLargeButton onClick={guardarDireccion} disabled={!calle}>
            Aceptar
          </SecondaryLargeButton>
        </ModalActionAddressFooter>
      </ModalActionAddressContent>
      <ModalInfo
        open={showModalInfo}
        setShowModal={setShowModalInfo}
        title="Error en la Dirección"
        description="Digita todos los campos obligatorios(Primera Nomenclatura y Campos Númericos)"
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
    </ModalActionAddressContainer>
  )
}

export default ModalActionAddress
